import MuiFormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel';
import EDTooltip from '../Tooltip/EDTooltip';

interface IProps extends FormControlLabelProps {
  disabledReason?: string;
}

/**
 * Komponent som lägger till en titel till en valfri kontroll, t.ex. en Switch.
 */
const EDFormControlLabel = (props: IProps) => {
  const { disabledReason, ...rest } = props;

  const formControlLabel = <MuiFormControlLabel {...rest} />;

  if (disabledReason) {
    return (
      <EDTooltip title={disabledReason} enableClickOnTouch>
        {formControlLabel}
      </EDTooltip>
    );
  }

  return formControlLabel;
};

export default EDFormControlLabel;
